import "./src/styles/article-overrides.css";

const SHARETHIS_SCRIPT_ID = "sharethis-script";
const SHARETHIS_SRC = "https://platform-api.sharethis.com/js/sharethis.js#property=67e8c5036eb4310012fddcf6&product=sticky-share-buttons";

const isArticlePath = (pathname = "") => /^\/\d{4}\/\d{2}\/.+\/?$/.test(pathname);

const initializeShareThis = () => {
	if (typeof window !== "undefined" && window.__sharethis__ && typeof window.__sharethis__.initialize === "function") {
		window.__sharethis__.initialize();
	}
};

const removeShareThisDom = () => {
	if (typeof document === "undefined") return;

	document.querySelectorAll(".sharethis-sticky-share-buttons, .sharethis-inline-share-buttons").forEach((node) => {
		node.remove();
	});

	document.querySelectorAll("[id^='st-']").forEach((node) => {
		node.remove();
	});
};

const disableShareThis = () => {
	if (typeof document === "undefined") return;

	removeShareThisDom();

	const script = document.getElementById(SHARETHIS_SCRIPT_ID);
	if (script) {
		script.remove();
	}

	if (typeof window !== "undefined") {
		delete window.__sharethis__;
	}
};

const enableShareThis = () => {
	if (typeof document === "undefined") return;

	const existingScript = document.getElementById(SHARETHIS_SCRIPT_ID);
	if (existingScript) {
		if (typeof window !== "undefined" && window.__sharethis__) {
			initializeShareThis();
		} else {
			existingScript.addEventListener("load", initializeShareThis, { once: true });
		}
		return;
	}

	const script = document.createElement("script");
	script.id = SHARETHIS_SCRIPT_ID;
	script.type = "text/javascript";
	script.src = SHARETHIS_SRC;
	script.async = true;
	script.onload = initializeShareThis;
	document.body.appendChild(script);
};

const syncShareThisByRoute = (pathname) => {
	if (isArticlePath(pathname)) {
		enableShareThis();
		return;
	}

	disableShareThis();
};

export const onInitialClientRender = () => {
	if (typeof window === "undefined") return;
	syncShareThisByRoute(window.location.pathname);
};

export const onRouteUpdate = ({ location }) => {
	syncShareThisByRoute(location?.pathname || "");
};